import { useMemo } from "react";

import { createIrrigationEventTracker } from "./create-irrigation-event-tracker";

/**
 * On-demand irrigation tracker: one zone at 100%, always a one-off. Thin wrapper over
 * createIrrigationEventTracker, memoized on zoneId so the tracker is stable across renders.
 */
export function useOnDemandIrrigationEventTracker(zoneId: string) {
    return useMemo(
        () => createIrrigationEventTracker({ creationMethod: "on_demand", zoneWateringPercentages: { [zoneId]: 1 } }),
        [zoneId],
    );
}
